

import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios';
import { MstContentsVO } from './vo/contents.vo';

@Component
export default class Introduction extends Vue {
  contents: MstContentsVO = {} as MstContentsVO;

  get getContents() {
    return this.contents;
  }

  created() {
    // 이용약관: 1, 개인정보보호방침: 2
    axios.get(`/common/content/1`)
    .then(r => {
      this.contents = r.data;
    })
  }
}
